export const features = {
  items: [
    {
      icon: 'fas fa-bolt',
      title: 'Fast',
      subtitle:
        'Instead of constantly worrying about when your home will be in demand',
    },
    {
      icon: 'fas fa-puzzle-piece',
      title: 'Integrity',
      subtitle:
        'Instead of constantly worrying about when your home will be in demand',
    },
    {
      icon: 'fas fa-bullseye',
      title: 'Targeted',
      subtitle:
        'Instead of constantly worrying about when your home will be in demand',
    },
    {
      icon: 'fas fa-bullhorn',
      title: 'Efficient',
      subtitle:
        'Instead of constantly worrying about when your home will be in demand',
    },
  ],
  properties: [
    'Our sign up is dead simple. We only require your basic company information',
    'We support bulk uploading via SQL, integrations with most data storage products',
    "Simply select where you'd like to transfer your data ",
  ],
};

export const mobileapp = [
  'Our sign up is dead simple. We only require your basic company information',
  'We support bulk uploading via SQL, integrations with most data storage products',
  "Simply select where you'd like to transfer your data ",
  'Affordable, scalable and performant. The perfect solution for small apps.',
];

export const howItWorks = [
  {
    icon: 'fas fa-bolt',
    title: 'Share',
    subtitle:
      'Our sign up is dead simple. We only require your basic company information',
  },
  {
    icon: 'fas fa-puzzle-piece',
    title: 'Send Message',
    subtitle:
      'We support bulk uploading via SQL, integrations with most data storage products',
  },
  {
    icon: 'fas fa-bullseye',
    title: 'Upload',
    subtitle:
      "Simply select where you'd like to transfer your data and we'll being the process of migrating it instantly.",
  },
];

export const pricings = [
  {
    title: 'Free Plan',
    price: '$0',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    isHighlighted: false,
  },
  {
    title: 'Premium Plan',
    price: '$79',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: true,
  },
];

export const partners = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
  {
    name: 'Instagram',
    logo: 'https://assets.maccarianagency.com/the-front/logos/instagram.svg',
  },
  {
    name: 'Netflix',
    logo: 'https://assets.maccarianagency.com/the-front/logos/netflix.svg',
  },
  {
    name: 'Pinterest',
    logo: 'https://assets.maccarianagency.com/the-front/logos/pinterest.svg',
  },
];

export const articles = [
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery1.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery1@2x.jpg 2x',
    },
    title: 'Increasing Prosperity With Positive Thinking',
    author: 'By Maria Stone',
    date: '03 March, 2019',
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery2.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery2@2x.jpg 2x',
    },
    title: 'Motivation Is The First Step To Success',
    author: 'By Georg Smith',
    date: '03 March, 2019',
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery3.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery3@2x.jpg 2x',
    },
    title: 'Success Steps For Your Personal Or Business Life',
    author: 'By Alex Nesi',
    date: '03 March, 2019',
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery1.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery1@2x.jpg 2x',
    },
    title: 'Increasing Prosperity With Positive Thinking',
    author: 'By Maria Stone',
    date: '03 March, 2019',
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery2.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery2@2x.jpg 2x',
    },
    title: 'Motivation Is The First Step To Success',
    author: 'By Georg Smith',
    date: '03 March, 2019',
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery3.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery3@2x.jpg 2x',
    },
    title: 'Success Steps For Your Personal Or Business Life',
    author: 'By Alex Nesi',
    date: '03 March, 2019',
  },
];

export const reviews = [
  {
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
];
